<template>
  <div>
    <v-row
      dense
      class="mb-2"
    >
      <v-col cols="12">
        <v-text-field
          v-model="search"
          label="Buscar"
          prepend-inner-icon="mdi-magnify"
          outlined
          dense
          clearable
          hide-details
          @keyup.enter="reload(true)"
          @click:clear="onClear"
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="total"
      :options.sync="options"
      :loading="loading"
      :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
      item-key="id"
      dense
    />

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="3000"
      top
    >
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
  import { $k } from '@/lib/kraken'

  export default {
    name: 'ReadOnlyDictTab',

    props: {
      headers: {
        type: Array,
        required: true,
      },
      sdkPath: {
        // dotted path under $k.manage.clinic_one.dictionaries.* — e.g. 'cbhpm', 'meios_pagamento'
        type: String,
        required: true,
      },
      label: {
        type: String,
        default: 'Dicionário',
      },
      // when true, only fetches once activated; resets when activated again
      lazy: {
        type: Boolean,
        default: true,
      },
      active: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      search: '',
      items: [],
      total: 0,
      options: { page: 1, itemsPerPage: 25 },
      loading: false,
      hasLoaded: false,
      snackbar: { show: false, color: 'success', text: '' },
    }),

    computed: {
      sdkNode () {
        const root = $k?.manage?.clinic_one?.dictionaries
        if (!root) return null
        return root[this.sdkPath] || null
      },
    },

    watch: {
      options: {
        deep: true,
        handler () {
          if (!this.lazy || this.active || this.hasLoaded) this.reload()
        },
      },
      active (val) {
        if (val && !this.hasLoaded) this.reload(true)
      },
    },

    mounted () {
      if (!this.lazy || this.active) this.reload(true)
    },

    methods: {
      onClear () {
        this.search = ''
        this.reload(true)
      },
      async reload (resetPage = false) {
        if (!this.sdkNode?.get) {
          this.snackbar = { show: true, color: 'error', text: `SDK ausente para "${this.sdkPath}". Reinstale o pacote @kraken/manage.` }
          return
        }
        if (resetPage && this.options.page !== 1) {
          this.options = { ...this.options, page: 1 }
          return
        }
        this.loading = true
        try {
          const skip = (this.options.page - 1) * this.options.itemsPerPage
          const payload = { skip, limit: this.options.itemsPerPage }
          if (this.search) payload.q = this.search
          const res = await this.sdkNode.get(payload)
          this.items = res.results || []
          this.total = res.total || 0
          this.hasLoaded = true
        } catch (err) {
          console.error(`[${this.sdkPath}.get]`, err)
          this.snackbar = {
            show: true,
            color: 'error',
            text: err?.response?.data?.messages?.error?.[0] || `Falha ao carregar ${this.label}.`,
          }
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>
